// extracted by mini-css-extract-plugin
export default {"checkWrapper":"CheckBox_checkWrapper__typvl","checked":"CheckBox_checked__AIy5U","scaleA":"CheckBox_scaleA__VC24-","text":"CheckBox_text__BmTTl","active":"CheckBox_active__P-4XZ"};